export type GameId = 'reaction' | 'aim' | 'tracking' | 'recall' | 'pressure' | 'decision';

export const GAMES: GameId[] = ['reaction', 'aim', 'tracking', 'recall', 'pressure', 'decision'];

export const GAME_META: Record<GameId, { label: string; chineseLabel: string; dimColor: string; theme: string }> = {
  reaction: { label: 'REACTION',  chineseLabel: '反应', dimColor: 'var(--dim-reaction)',  theme: 'reactor-bay' },
  aim:      { label: 'AIM',       chineseLabel: '精度', dimColor: 'var(--dim-aim)',       theme: 'precision-range' },
  tracking: { label: 'TRACKING',  chineseLabel: '跟瞄', dimColor: 'var(--dim-tracking)',  theme: 'suppression-arc' },
  recall:   { label: 'RECALL',    chineseLabel: '记忆', dimColor: 'var(--dim-recall)',    theme: 'tactical-sandbox' },
  pressure: { label: 'PRESSURE',  chineseLabel: '抗压', dimColor: 'var(--dim-pressure)',  theme: 'ops-deck' },
  decision: { label: 'DECISION',  chineseLabel: '决策', dimColor: 'var(--dim-decision, #7cf7ff)', theme: 'command-room' },
};

export type Scores = Record<GameId, { score: number; raw: Record<string, number> }>;
